// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"a0c14f2a","356":"8fae3b9a","496":"ce666060"}[chunkId] + ".chunk.js";
};